import { TagFamilyMemberType } from '../../../../../schemas';

export const defaultNode = (): TagFamilyMemberType => ({
  name: '',
  description: '',
  allowMultiple: false,
  children: [],
});

export function updateChildrenAtPath(
  path: Array<number>,
  data: Array<TagFamilyMemberType>,
  newChildren: Array<TagFamilyMemberType>,
): Array<TagFamilyMemberType> {
  if (path.length === 0) {
    return newChildren;
  }

  const [head, ...rest] = path;
  return data.map((item, idx) => {
    if (idx !== head) return item;
    if (rest.length === 0) {
      return {
        ...item,
        children: newChildren,
      };
    } else {
      return {
        ...item,
        children: updateChildrenAtPath(rest, item.children || [], newChildren),
      };
    }
  });
}

export function addChildAtPath(
  path: Array<number>,
  data: Array<TagFamilyMemberType>,
  child: TagFamilyMemberType,
): Array<TagFamilyMemberType> {
  if (path.length === 0) {
    return [...data, child];
  }
  const [head, ...rest] = path;
  return data.map((item, idx) => {
    if (idx !== head) return item;
    if (rest.length === 0) {
      return {
        ...item,
        children: [...(item.children || []), child],
      };
    } else {
      return {
        ...item,
        children: addChildAtPath(rest, item.children || [], child),
      };
    }
  });
}

export function deleteNodeByPath(
  path: Array<number>,
  data: Array<TagFamilyMemberType>,
): Array<TagFamilyMemberType> {
  if (path.length === 1) {
    return data.filter((_, idx) => idx !== path[0]);
  }
  const [head, ...rest] = path;
  return data.map((item, idx) =>
    idx === head
      ? {
          ...item,
          children: deleteNodeByPath(rest, item.children || []),
        }
      : item,
  );
}

export function updateNodeByPath(
  path: Array<number>,
  data: Array<TagFamilyMemberType>,
  newNode: TagFamilyMemberType | Array<TagFamilyMemberType>,
): Array<TagFamilyMemberType> {
  if (path.length === 0) {
    return Array.isArray(newNode) ? newNode : data;
  }

  const [head, ...rest] = path;
  return data.map((item, idx) => {
    if (idx !== head) return item;
    if (rest.length === 0) {
      return Array.isArray(newNode) ? item : { ...item, ...newNode };
    } else {
      return {
        ...item,
        children: updateNodeByPath(rest, item.children || [], newNode),
      };
    }
  });
}

export const ROOT_NODE_NAME = 'ROOT';

export function ensureRootNode(
  data: Array<TagFamilyMemberType>,
  allowMultiple: boolean,
): Array<TagFamilyMemberType> {
  if (data?.length === 1 && data[0].name === ROOT_NODE_NAME && Array.isArray(data[0].children)) {
    return data;
  }
  return [
    {
      name: ROOT_NODE_NAME,
      allowMultiple,
      children: data,
    },
  ];
}
